module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/description-pict-d9c98543e930ace19918ee02c5155ba0.jpg";